import {
    SET_SECONDARY_BAR_TYPE,
    SET_SECONDARY_BAR_TYPE_3,
    TOGGLE_SECONDARY_BAR,
    TOGGLE_SECONDARY_BAR_3,
} from "app/action_types/secondary_bar_action_types";
import { SecondarySideBarType3 } from "app/components/sidebar3/types";

export type SecondaryBarType =
    | "MarketResearch"
    | "DigitalSuiteMarketResearch"
    | "DigitalSuiteCompetition"
    | "DigitalSuiteTrackers"
    | "DigitalSuiteAcquisition"
    | "DigitalMarketing"
    | "WebsiteResearch"
    | "Dashboards"
    | "MarketingWorkspace"
    | "SalesWorkspace"
    | "InvestorsWorkspace"
    | "AppResearch"
    | "DigitalSuite"
    | "ConversionAnalysis"
    | "PremiumFeatures"
    | "CustomInsights"
    | "SalesIntelligence"
    | "SalesIntelligenceHome"
    | "SalesIntelligenceFind"
    | "SalesIntelligenceFindApps"
    | "SalesIntelligenceManagement"
    | "SalesIntelligenceAccountReview"
    | "SalesIntelligenceAppReview"
    | "SalesIntelligenceIntent"
    | "SalesIntelligenceLists"
    | "BenchmarkTracker"
    | "MonitorAndProtect"
    | "Activation"
    | "None";

export interface ISecondaryBarReducer {
    /**
     * Indicates whether the navbar is opened or not
     */
    isSecondaryBarOpen: boolean;

    /**
     * Indicates which nav bar is currently displayed
     */
    secondaryBarType: SecondaryBarType;

    // For sidebar 3
    /**
     * Indicates whether the navbar is opened or not
     */
    isSecondaryBar3Open: boolean;

    /**
     * Indicates which nav bar is currently displayed
     */
    secondaryBarType3: SecondarySideBarType3;
}

function getDefaultState(): ISecondaryBarReducer {
    return {
        secondaryBarType: "None",
        isSecondaryBarOpen: true,
        secondaryBarType3: SecondarySideBarType3.None,
        isSecondaryBar3Open: true,
    };
}

function secondaryBar(state: ISecondaryBarReducer = getDefaultState(), action: FixmeType): ISecondaryBarReducer {
    switch (action.type) {
        case TOGGLE_SECONDARY_BAR:
            return {
                ...state,
                isSecondaryBarOpen: action.isSecondaryBarOpen,
            };

        case SET_SECONDARY_BAR_TYPE:
            return {
                ...state,
                secondaryBarType: action.secondaryBarType,
            };
        case TOGGLE_SECONDARY_BAR_3:
            return {
                ...state,
                isSecondaryBar3Open: action.isSecondaryBar3Open,
            };

        case SET_SECONDARY_BAR_TYPE_3:
            return {
                ...state,
                secondaryBarType3: action.secondaryBarType3,
            };

        default:
            return state;
    }
}

export default secondaryBar;
